












import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component({
  components: {},
})
export default class Home extends Vue {
  @Prop({ type: Boolean, default: false }) public bannerShow;
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  public detail;
}
